import {showErrorPopup} from "../util/errors.js";
import {restCreate, restDelete} from "../util/http.js";
import {PkToggle} from "./pk-toggle.js";
import {successAlert} from "../alerts.js";


export class PkLiveToggle extends PkToggle {

    static properties = {
        toggleMessage: {type: String},
        toggleMessageIcon: {},
        toggleMessageIconType: {},
        toggleMessageIconCollection: {},
        toggleOffMessage: {type: String},
        toggleOffMessageIcon: {},
        toggleOffMessageIconType: {},
        toggleOffMessageIconCollection: {},
    }

    async onChangeHandler(e) {
        if (!this.disabled && !this.isToggleRequested) {
            if (this.dispatchEvent(new Event('beforechange', {bubbles: true, cancelable: true})) === false) {
                this.inputRef.value.checked = this.checked;
                return;
            }
            await this.#requestToggleUpdate(!!e.target.checked);
        }
        this.requestUpdate();
    }

    async toggle() {
        this.inputRef.value.checked = !this.checked;
        return this.#requestToggleUpdate(!this.checked);
    }

    async #requestToggleUpdate(value) {
        this.isToggleRequested = true;
        try {
            if (value && !this.checked) {
                await restCreate(this.url);
            } else if (!value && this.checked) {
                await restDelete(this.url);
            }
            this.checked = !!value;
            this.dispatchEvent(new Event('change', {bubbles: true}));
            this.#showOnChangeMessage();
        } catch (e) {
            showErrorPopup(e, {useToasts: true});
            this.requestUpdate();
        }
        this.inputRef.value.checked = this.checked;
        this.isToggleRequested = false;
    }

    #showOnChangeMessage() {
        const message = this.checked
            ? this.toggleMessage
            : (this.toggleOffMessage || this.toggleMessage);

        if (message) {
            successAlert(message, {
                useToasts: true,
                icon: this.checked ? this.toggleMessageIcon : (this.toggleOffMessageIcon || this.toggleMessageIcon),
                iconType: this.checked ? this.toggleMessageIconType : (this.toggleOffMessageIconType || this.toggleMessageIconType),
                iconCollection: this.checked ? this.toggleMessageIconCollection : (this.toggleOffMessageIconCollection || this.toggleMessageIconCollection),
            });
        }

        // if (this.checked && this.toggleMessage) {
        //     return successAlert(this.toggleMessage, {useToasts: true});;
        // }
        // if (!this.checked && (this.toggleMessage || )) {

        // toggleOffMessage
    }

}

customElements.define('pk-live-toggle', PkLiveToggle);
